import React, { useCallback, useContext, useState } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import { DeviceManagerContext } from '@trainline-shareable/device-manager';
import * as styles from './style.module.css';
import { setMultipleRefs } from '../../../_shared/helpers';
const FooterWithoutRef = ({ footerContent, footerActions, mobileModalFooterDirection = 'vertical', innerRef, className, ...commonProps }) => {
    // States
    const [footerHeight, setFooterHeight] = useState(0);
    // Contexts
    const deviceManager = useContext(DeviceManagerContext);
    // Derived values
    /* Force 'vertical' direction on mobile if there are 2 footer actions and content */
    const footerDirection = (footerActions === null || footerActions === void 0 ? void 0 : footerActions.length) === 2 && footerContent
        ? 'vertical'
        : mobileModalFooterDirection;
    const isMobileViewport = /(X?S)/.test((deviceManager === null || deviceManager === void 0 ? void 0 : deviceManager.viewPort) || 'S');
    // Classes
    const footerWrapperClasses = clsx(styles.footer, {
        [styles.mobileViewport]: isMobileViewport,
    }, mobileModalFooterDirection && styles[footerDirection]);
    const buttonGroupClasses = clsx(styles.buttonGroup, {
        [styles.mobileViewport]: isMobileViewport,
        [styles[footerDirection]]: mobileModalFooterDirection,
        [styles.twoButtons]: (footerActions === null || footerActions === void 0 ? void 0 : footerActions.length) === 2 && !footerContent,
    });
    const innerDivClasses = clsx(className, footerWrapperClasses);
    // Refs
    const footerRef = useCallback((element) => {
        if (element && isMobileViewport) {
            setFooterHeight(element.clientHeight);
        }
    }, [isMobileViewport]);
    return (React.createElement(React.Fragment, null,
        isMobileViewport && (React.createElement("div", { className: clsx(styles.footerShadow), style: { bottom: `${footerHeight}px` } })),
        Depot.createElement('div', {
            ...commonProps,
            className: innerDivClasses,
            innerRef: setMultipleRefs([footerRef, innerRef]),
        }, React.createElement(React.Fragment, null,
            footerContent,
            footerActions && (React.createElement("div", { className: buttonGroupClasses }, footerActions.map((action, i) => {
                return React.createElement(action.type, { ...action.props, key: i });
            })))))));
};
const Footer = Depot.withRef(FooterWithoutRef);
Footer.displayName = 'Footer';
export default Footer;
//# sourceMappingURL=index.js.map